import { render } from "./AdminCreate.vue?vue&type=template&id=c65930e2&scoped=true"
import script from "./AdminCreate.vue?vue&type=script&lang=js"
export * from "./AdminCreate.vue?vue&type=script&lang=js"

import "./AdminCreate.vue?vue&type=style&index=0&id=c65930e2&scoped=true&lang=css"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c65930e2"]])

export default __exports__